export default {"src":"/_next/static/media/icon-four.6cc5b56b.svg","height":22,"width":22};